import { useReveal } from "@/hooks/useReveal";

const INDUSTRIES = [
  {
    name: "Bakery and confectionery",
    line: "Pulverised cane sugar dissolves cleanly in doughs and syrups; cocoa powder for fillings and coatings.",
  },
  {
    name: "Chocolate makers",
    line: "Unrefined cane sugar for bean-to-bar formulations that carry an organic claim.",
  },
  {
    name: "Cereal bars and snacks",
    line: "Binding syrups and coatings where a certified organic sweetener is required.",
  },
  {
    name: "Beverages and juices",
    line: "Pulverised grade for cold-dissolution applications.",
  },
  {
    name: "Dairy and desserts",
    line: "Cocoa powder at 15% fat for stable colour and flavour in milk-based systems.",
  },
  {
    name: "Craft brewing",
    line: "Unrefined cane sugar for priming and for fermentation adjuncts.",
  },
  {
    name: "Infant and specialised food",
    line: "Documented traceability and additive-free specification.",
  },
  {
    name: "Natural cosmetics",
    line: "Cane sugar as an exfoliant base; cocoa butter available separately.",
  },
];

export default function Applications() {
  const headRef = useReveal<HTMLDivElement>();
  const gridRef = useReveal<HTMLDivElement>();

  return (
    <section id="applications" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={headRef} className="reveal flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div className="max-w-[800px]">
            <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
              Where it is used
            </h2>
            <p className="mt-4 text-ink/70 text-lg leading-relaxed">
              Anchored by industry, so you can go straight to yours.
            </p>
          </div>
          <img
            src="https://readdy.ai/api/search-image?query=Extreme%20macro%20photograph%20of%20dark%20brown%20cocoa%20powder%20texture%20with%20fine%20particles%2C%20soft%20natural%20light%2C%20earthy%20warm%20tones%2C%20neutral%20technical%20laboratory%20aesthetic%2C%20clean%20minimal%20composition%2C%20high%20detail%20close%20up&width=800&height=600&seq=ingredients-cocoa-macro-01&orientation=landscape"
            alt="Macro detail of fine organic cocoa powder texture"
            className="hidden md:block w-[280px] h-[180px] object-cover object-top rounded-lg shrink-0"
          />
        </div>

        <div
          ref={gridRef}
          className="reveal mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {INDUSTRIES.map((item) => (
            <div
              key={item.name}
              className="bg-cream rounded-lg border border-cream-dark/50 p-5"
            >
              <h3 className="text-ink font-serif text-base md:text-lg font-semibold leading-snug">
                {item.name}
              </h3>
              <p className="mt-2 text-ink/70 text-sm leading-relaxed">
                {item.line}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}